import axios from "../../axiosConfig";

export const normalizeOrganizationSurveys = (payload) => {
  const surveys = Array.isArray(payload) ? payload : payload?.surveys;
  return Array.isArray(surveys) ? surveys : [];
};

const normalizeScopedOrganizationSurveysPayload = (payload) => {
  const surveys = normalizeOrganizationSurveys(payload).map((survey) => ({
    ...survey,
    organization_survey_id: survey?.organization_survey_id ?? survey?.id,
    name: survey?.name ?? survey?.survey?.name,
    language: survey?.language ?? survey?.survey?.language,
    workbook_usable: survey?.workbook_usable ?? true,
  }));

  return {
    recommended_workbook_organization_survey_id:
      payload?.recommended_workbook_organization_survey_id ??
      surveys.find((survey) => survey?.workbook_usable !== false)?.organization_survey_id ??
      null,
    surveys,
  };
};

export const fetchOrganizationSurveysPayload = async ({ organizationId = null } = {}) => {
  if (organizationId) {
    const response = await axios.get(`/organizations/${organizationId}/organization_surveys`);
    return normalizeScopedOrganizationSurveysPayload(response.data);
  }

  const response = await axios.get("/organizations/me/surveys");
  return response.data;
};

export const hasUsableWorkbookSurvey = (payload) => {
  if (payload?.recommended_workbook_organization_survey_id) return true;

  return normalizeOrganizationSurveys(payload).some(
    (survey) => survey?.workbook_usable === true
  );
};

export const fetchWorkbookAvailability = async (organizationId) => {
  if (!organizationId) return false;

  const response = await axios.get(`/organizations/${organizationId}/organization_surveys`);
  return hasUsableWorkbookSurvey(normalizeScopedOrganizationSurveysPayload(response.data));
};

export const fetchOrganizationSurveys = async () => {
  const payload = await fetchOrganizationSurveysPayload();
  return normalizeOrganizationSurveys(payload);
};

export const getOrganizationSurvey = async (organizationId, organizationSurveyId) => {
  const response = await axios.get(
    `/organizations/${organizationId}/organization_surveys/${organizationSurveyId}`
  );

  const data = response.data;

  return {
    ...data,
    organization_survey_id: data?.organization_survey_id || data?.id,
  };
};

export const updateOrganizationSurvey = async (
  organizationId,
  organizationSurveyId,
  payload
) => {
  const requestPayload = {
    start_date: payload?.start_date,
    end_date: payload?.end_date,
    roles: Array.isArray(payload?.roles) ? payload.roles : [],
    opening_message: payload?.opening_message ?? "",
    closing_message: payload?.closing_message ?? "",
    passcode: payload?.passcode ?? "",
  };

  console.log("Updating survey payload:", requestPayload);

  try {
    const response = await axios.patch(
      `/organizations/${organizationId}/organization_surveys/${organizationSurveyId}`,
      requestPayload
    );

    return response.data;
  } catch (error) {
    console.error(error.response?.data);
    throw error;
  }
};

export const getOrganizationSurveys = fetchOrganizationSurveys;
